import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ViewRemitos} from "../../models/ViewRemitos";
import {FormBuilder, FormControl, FormGroup, FormGroupDirective} from "@angular/forms";
import {RemitoService} from "../../services/remito.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {RemitoVehicle} from "../../models/RemitoVehicle";
import {RemitoVehicleService} from "../../services/remito-vehicle.service";
import {ViewVehicle} from "../../models/ViewVehicle";

@Component({
  selector: 'app-popup-cancel-vehicle-dialog',
  templateUrl: './popup-cancel-vehicle-dialog.component.html',
  styleUrls: ['./popup-cancel-vehicle-dialog.component.scss']
})
export class PopupCancelVehicleDialogComponent implements OnInit {

  isReadOnly: boolean = false;
  message: string;
  remito: ViewVehicle = new ViewVehicle();
  titleText: string = "Cancelar Remito";
  observacionControl = new FormControl({value: '', disabled: this.isReadOnly});
  fechaControl = new FormControl({value: new Date(), disabled: true});
  cancelForm = new FormGroup({
    observacionControl: this.observacionControl,
    fechaControl: this.fechaControl
  });
  @ViewChild('formDirective') private formDirective: FormGroupDirective;

  /**
   * Dialog appearance is determined by the {@link `data`} sent over when it is opened.
   *
   * If the Remito was previously cancelled, the dialog will be readonly,
   * [`Fecha`]{@link viewRemito.cancelarFecha} and [`Observaciones`]{@link viewRemito.cancelarObservacion}
   * will be prepopulated, and the [`Title`]{@link titleText} will reflect that the dialog is cancelled.
   * The user will only have the option to exit the dialog.
   *
   * Otherwise, [`Observaciones`]{@link observacionControl} is a required text field,
   * [`Fecha`]{@link fechaControl} will be populated with the current date, the [`Title`]{@link titleText}
   * will instruct the user to cancel the Remito, and a `Submit` button will be shown.
   *
   * Once submitted, the Remito status updates to cancelled in the database, the table reflects the
   * cancellation changes, and reopening the dialog shows the cancellation details, as outlined above.
   * @param remitoService     Backend endpoint for updating database
   * @param cancelFormBuilder The HTML form
   * @param dialogRef         Returns data when the dialog is closed
   * @param data              Data sent over when dialog is opened
   */
  constructor(
    private remitoService: RemitoVehicleService,
    private cancelFormBuilder: FormBuilder,
    private dialogRef: MatDialogRef<PopupCancelVehicleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.remito = Object.assign(data.remito);
    this.isReadOnly = data.isReadOnly;

    if (this.isReadOnly) {
      this.titleText = `Remito ${this.remito.nroRemito} Cancelado`;
      this.observacionControl.setValue(this.remito.cancelarObservacion);
      this.observacionControl?.disable();
      this.fechaControl.setValue(this.remito.cancelarFecha);
    } else {
      this.titleText = `Cancelar Remito ${this.remito.nroRemito}`;
    }

  }

  ngOnInit() {
    this.cancelFormBuilder.group(
      {
        observacionControl: this.observacionControl,
        fechaControl: this.fechaControl
      },
      {
        updateOn: "change"
      });
  }

  /**
   * On submit, [`cancelarFecha`]{@link viewRemito.cancelarFecha} is updated with the current date and
   * [`cancelarObservacion`]{@link viewRemito.cancelarObservacion} is updated with the given text.
   * Next, the updated [`viewRemito`]{@link viewRemito} is sent to the backend endpoint to update the
   * database. Finally, the {@link `data`} is returned so that the Remito can be updated on the table.
   */
  public confirm() {
    if (!this.observacionControl.hasError('required')) {
      this.remito.cancelarFecha = this.fechaControl.value;
      this.remito.cancelarObservacion = this.observacionControl.value;
      this.remitoService.cancelRemito(this.remito).subscribe(data => {
        if (data === null) {
          this.dialogRef.close("error")
        }
        this.dialogRef.close(data);
      });
    }
  }
  /**
   * Closes the dialog without submission. No changes occur.
   */
  public exit() {
    this.dialogRef.close();
  }

}
